import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { emailResetPass } from "../../apis/resetPass";

export default function SendOTPResetPassButton({
  errorEmailPhone,
  setErrorEmailPhone,
  emailPhoneValue,
  navigateTo,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?[0-9]\d{9}$/;
  const handleSendOTP = async () => {
    if (errorEmailPhone === "" && emailPhoneValue !== "") {
      if (emailRegex.test(emailPhoneValue)) {
        console.log("Sending OTP to email:", emailPhoneValue);
        const result = await emailResetPass(emailPhoneValue);
        console.log(result);
      } else if (phoneRegex.test(emailPhoneValue)) {
        console.log("Sending OTP to phone number:", emailPhoneValue);
        setTimeout(() => {
          navigate(navigateTo); // Replace '/next-page' with your desired path
        }, 1000);
      }
      //API CALL HERE
    } else {
      setErrorEmailPhone("invalid_email_or_phone");
    }
  };
  return <PrimaryButton text={t("send_otp")} onClick={handleSendOTP} />;
}
